import { css } from '@emotion/css';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ZodiacSignIcon } from 'src/components/Passport/card/ZodiacSignIcon';
import { CharacterImage } from 'src/components/shared/CharacterImage';
import { MiniRibbon } from 'src/components/shared/MiniRibbon';
import { interpolateFreeText } from 'src/i18n';
import { zodiacSignFromBirthday } from 'src/models/ZodiacSign';

export interface UserInfoProps {
  name: string;
  imageUrl: string;
  birthday: { month: number; day: number };
}

const userInfoBg =
  'data:image/svg+xml,%3Csvg width="62" height="40" viewBox="0 0 62 40" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M33.858 34.42A19.933 19.933 0 0120 40C8.954 40 0 31.046 0 20S8.954 0 20 0c7.57 0 14.158 4.206 17.554 10.408A15.925 15.925 0 0146 8c8.837 0 16 7.163 16 16s-7.163 16-16 16a15.964 15.964 0 01-12.142-5.58z" fill="%23DEC2FF"/%3E%3C/svg%3E';

export const UserInfo: React.FC<UserInfoProps> = ({ name, imageUrl, birthday }) => {
  const { t } = useTranslation(['fortune', 'translation']);
  const zodiacSign = zodiacSignFromBirthday(birthday.month, birthday.day);
  const zodiacSignName = t(`translation:zodiac_${zodiacSign.toLocaleLowerCase()}`);
  return (
    <div
      className={css`
        position: relative;
        display: inline-block;

        .images {
          width: 62px;
          padding: 4px;
          margin: 0 auto;
          position: relative;
          background-image: url('${userInfoBg}');
        }
        .user-image {
          position: relative;
          width: 32px;
          height: 32px;
          margin-right: 24px;
          z-index: 1;
        }
        .zodiac-sign {
          position: absolute;
          bottom: 4px;
          right: 4px;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background-color: #f5f1e3;
        }
        .dear-user {
          font-size: 12px;
          position: relative;
          top: -8px;
          z-index: 2;
        }
      `}
    >
      <div role="img" className="images" aria-labelledby={'user-image zodiac-sign'}>
        <div className="user-image">
          <CharacterImage
            isPlayer={true}
            src={imageUrl}
            imageId={'user-image'}
            imageAriaLabel={name}
          />
        </div>
        <div className="zodiac-sign">
          <ZodiacSignIcon zodiacSign={zodiacSign} ariaLabel={zodiacSignName} />
        </div>
      </div>
      <div className="dear-user">
        <MiniRibbon backgroundColor="#dec2ff" textColor="#4d3906">
          <p>{interpolateFreeText(t, 'fortune:dear_user', 'user', name)}</p>
        </MiniRibbon>
      </div>
    </div>
  );
};
